module.exports = __webpack_public_path__ + "img/no-note.91a35632.png";